export default __webpack_public_path__ + "static/civea-5de3bf32ae112d9151b70439824aa6b9.svg";